export default __webpack_public_path__ + "static/media/Feed-The-Tribe-Oct.f7bd81be.jpg";